import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-doctor-details',
  templateUrl: './doctor-details.component.html',
  styleUrls: ['./doctor-details.component.scss']
})
export class DoctorDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  modDocDetails

  @Input() dataSet: any
}
